import { EstimateMassUnit, MassUnit } from '@lune-climate/lune'
import { ThirtyDayStatistics } from '@lune-fe/dapi-models'
import { WtwBreakdownExplanation } from '@lune-fe/lune-components-lib'
import { LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

const { palette } = LuneThemeNew

const WtwBreakdown: FC<{
    breakdown: ThirtyDayStatistics['logisticsWtwBreakdown']
}> = ({ breakdown }) => {
    const CONTENT_HEIGHT = '72px'

    const hasData =
        breakdown &&
        (parseFloat(breakdown.wtt) > 0 ||
            parseFloat(breakdown.ttw) > 0 ||
            parseFloat(breakdown.unknown) > 0)

    if (!hasData) {
        return (
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: 3,
                    height: CONTENT_HEIGHT,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3,
                        flexWrap: 'wrap',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <Box
                            sx={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: palette.Data100,
                            }}
                        />
                        <Text variant={'body3'}>Well-To-Tank:</Text>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <Box
                            sx={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: palette.Data300,
                            }}
                        />
                        <Text variant={'body3'}>Tank-To-Wheel:</Text>
                    </Box>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        height: '8px',
                        backgroundColor: palette.Surface500,
                    }}
                />
            </Box>
        )
    }

    const normalized = {
        wtt: {
            amount: breakdown.wtt,
            unit: EstimateMassUnit.T,
        },
        ttw: {
            amount: breakdown.ttw,
            unit: EstimateMassUnit.T,
        },
        unknown: {
            amount: breakdown.unknown,
            unit: EstimateMassUnit.T,
        },
    }

    return (
        <WtwBreakdownExplanation
            sx={{
                width: '100%',
                height: CONTENT_HEIGHT,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                '> div': {
                    // legend
                    ' > div:first-of-type': {
                        mt: 0,
                        mb: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        '> div': {
                            p: 0,
                            display: 'flex',
                            alignItems: 'center',
                        },
                    },
                    // bar
                    ' > div:last-of-type': {
                        paddingBottom: 0,
                        pt: '18px',
                    },
                },
            }}
            wtwDetails={normalized}
            emissionsUnit={MassUnit.T}
            legendOptions={{
                ontop: true,
                vertical: false,
            }}
        />
    )
}

export default WtwBreakdown
